function searchSessionParamsTypeTags({ roleType, typeTags, fromDate, toDate, toString = false, term, size}) {

  const params = {
    queryRoleType: roleType,
    typeTags: typeTags,
  }
  if(fromDate)
    params.fromDate = fromDate;
  if(toDate)
    params.toDate = toDate;
  if(term)
    params.term = term;
  if(size)
    params.size = size;


  //  "fromDate": "2021-11-06T09:11:18.584Z",
  // "toDate": "2021-11-06T09:11:18.584Z",
  // "page": 0,
  // "size": 0,
  // "sortProperties": [
  //   "string"
  // ],
  // "direction": "ASC or DESC"
  params.direction = "DESC"
  params.sortProperties = ['date', 'videoItem.id']

  console.log(JSON.stringify(params))
  return toString ?
    JSON.stringify(params) :
    params
}

export const anonymousUtils = {
  searchSessionParamsTypeTags
}
